module.exports = __webpack_public_path__ + "static/Carly_Daniel7-ec471e3b119b15ded9f1992858f9bc7d.jpg";